import { useReveal } from "../hooks/useReveal";
import { SERVICE_TAGS } from "../data/reels";

// Hand-placed positions (percent) — distributed with rhythm, not a grid
const POSITIONS = [
  { top: "4%", left: "52%", rot: -3 },
  { top: "14%", left: "12%", rot: 2 },
  { top: "22%", left: "72%", rot: 4 },
  { top: "32%", left: "18%", rot: -2 },
  { top: "50%", left: "58%", rot: 3 },
  { top: "60%", left: "10%", rot: -4 },
  { top: "72%", left: "40%", rot: 2 },
  { top: "84%", left: "60%", rot: -3 },
];

export const ServiceTags = () => {
  const ref = useReveal();
  return (
    <section id="modos" className="relative py-16 sm:py-24 px-5">
      <div ref={ref} className="reveal max-w-5xl mx-auto">
        <h3 className="display text-center text-[28px] sm:text-[40px] lg:text-[52px] mb-10 sm:mb-12">
          <span className="mono text-[color:var(--mr-muted)] text-base sm:text-lg align-middle mr-2">[</span>
          nuestros modos de crear
          <span className="mono text-[color:var(--mr-muted)] text-base sm:text-lg align-middle ml-2">]</span>
        </h3>

        {/* Mobile: wrap cloud */}
        <div className="sm:hidden flex flex-wrap gap-3 justify-center">
          {SERVICE_TAGS.map((t, i) => (
            <span
              key={i}
              data-testid={`tag-${t.label}`}
              className={`tag-pill inline-block px-5 py-2.5 rounded-full text-white font-semibold text-sm mono ${
                t.color === "fuchsia" ? "bg-[color:var(--mr-fuchsia)]" : "bg-[color:var(--mr-purple)]"
              }`}
              style={{ transform: `rotate(${(i % 3) - 1}deg)` }}
            >
              {t.label}
            </span>
          ))}
        </div>

        {/* Desktop: floating placement */}
        <div className="hidden sm:block relative mx-auto" style={{ height: 520, maxWidth: 780 }}>
          {SERVICE_TAGS.map((t, i) => (
            <span
              key={i}
              data-testid={`tag-desktop-${t.label}`}
              className={`tag-pill floaty absolute px-6 py-2.5 rounded-full text-white font-semibold text-base mono ${
                t.color === "fuchsia" ? "bg-[color:var(--mr-fuchsia)]" : "bg-[color:var(--mr-purple)]"
              }`}
              style={{
                top: POSITIONS[i].top,
                left: POSITIONS[i].left,
                "--r": `${POSITIONS[i].rot}deg`,
                transform: `rotate(${POSITIONS[i].rot}deg)`,
                animationDelay: `${i * 0.3}s`,
              }}
            >
              {t.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
